import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    submit: 'Continue',
    taskName: 'Task Name',
    taskNameHelp: 'Create a name that perfectly describes the task you needed',
    executeTitle: 'Execute',
    contractAddressLabel: 'Contract Address',
    automizedLabel: 'Function to be automated',
    gasLimitLabel: 'Gas limit',
    customData: 'Custom Data',
    gasLimitHelp:
      'Amount of gas for target contract upkeep. This affects minimum balance requirements and should be roughly the same as the maximum amount of gas for the transaction.',
    abiFetched: 'ABI fetched',
    amountInWei: 'Enter the amount in wei',
  },
};
